<ng-container *transloco="let t">
  @let indexedFields = indexedCustomFields();

  @if (indexedFields && indexedFields.length > 0) {
    @for (indexed of indexedFields; track indexed.field.name) {
      <app-custom-field
        [customField]="indexed.field"
        [value]="customFieldDetailValues()[indexed.originalIndex]"
        (valueChange)="onUpdateCustomFieldDetailValue(indexed.originalIndex, $event)"
        [displayErrors]="isFormSubmitted()"
      />
    }
  }
</ng-container>
